/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const mythos_chain_about = () => `Mythos aims to democratize the gaming world and allow for players and creators to participate in the value chain. It is grounded in the support of multi-chain ecosystems, unified marketplaces, decentralized financial systems, decentralized governance mechanisms and multi-token game economies.`
